module.exports = __webpack_public_path__ + "static/media/dodo.2de7ab26.png";